( function( $ ) {
	let initBlock = function( section = false ) {		
		const $section = section ? $( section ) : $( '.section-careers' );

		$section.find( '.js-section-careers' ).each( function() {
			let $this = $( this );
			let $sliderCareers = $this;
			let slidesCount = $sliderCareers.find( '.swiper-slide' ).length;
			let looping = true;

			if ( slidesCount < 2 ) {
				looping = false;
			}

			if ( $sliderCareers[0].swiper ) {
				this.swiper.destroy( true, true );
			}

			const loadSliderCareers = () => {
				new Swiper( $sliderCareers[0], {
					slidesPerView: 1,
					speed: 1000,
					effect: 'fade',
					spaceBetween: 0,
					fadeEffect: {
						crossFade: true,
					},
					loop: looping,
					loopedSlides: 10,
					loopAdditionalSlides: 10,
					navigation: {
						nextEl: $this.closest( '.section-careers__slider-wrapper' ).find( '.section-careers__slider-nav .swiper-button-next' )[0],
						prevEl: $this.closest( '.section-careers__slider-wrapper' ).find( '.section-careers__slider-nav .swiper-button-prev' )[0],
					},
					pagination: {
						el: $this.closest( '.section-careers__slider-wrapper' ).find( '.section-careers__slider-nav .section-careers__slider-pagination' )[0],
						type: 'fraction',
					},
				} );
			};
			window.app.loadVendor( 'Swiper', loadSliderCareers );
		} );
	};

	window.app.loadBlock( initBlock, 'section-careers', '.section-careers' );
} )( jQuery );